globalThis["__sentryRewritesTunnelPath__"] = undefined;
globalThis["SENTRY_RELEASE"] = {"id":"7cda82b89818427c88936f9733c12633a91c6211"};
globalThis["__sentryBasePath"] = undefined;
globalThis["__rewriteFramesAssetPrefixPath__"] = "";
// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import {
  init as initSentry,
  inboundFiltersIntegration,
  functionToStringIntegration,
  browserApiErrorsIntegration,
  breadcrumbsIntegration,
  globalHandlersIntegration,
  linkedErrorsIntegration,
  dedupeIntegration,
  httpContextIntegration,
  thirdPartyErrorFilterIntegration,
} from '@sentry/nextjs';
import { IGNORED_ERRORS, SENTRY_DSN } from './sentry-common.config';

if (process.env.NEXT_PUBLIC_SENTRY_ENABLED === 'true') {
  initSentry({
    dsn: SENTRY_DSN,

    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.1,

    // Setting this option to true will print useful information to the console while you're setting up Sentry.
    debug: true,

    replaysOnErrorSampleRate: 1.0,

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,

    sendDefaultPii: false,

    integrations: [
      inboundFiltersIntegration(),
      functionToStringIntegration(),
      browserApiErrorsIntegration(),
      breadcrumbsIntegration(),
      globalHandlersIntegration(),
      linkedErrorsIntegration(),
      dedupeIntegration(),
      httpContextIntegration(),
      thirdPartyErrorFilterIntegration({
        filterKeys: ['web-veskit-verbid-laelia'],
        behaviour: 'drop-error-if-exclusively-contains-third-party-frames',
      }),
    ],
    ignoreErrors: IGNORED_ERRORS,
    denyUrls: [
      /^https:\/\/www.datadoghq-browser-agent.com\/us1/,
      /^https:\/\/[a-zA-Z0-9.-]+\.awswaf.com/,
      /^https:\/\/cdn\.apple-mapkit\.com/,
    ],

    beforeSend(event) {
      if (event.request?.cookies) {
        delete event.request.cookies;
      }
      return event;
    },
  });
}
